import { Component } from '@angular/core';

@Component({
  templateUrl: './privacy.component.html',
  styleUrls: ['../oss/oss.component.less']
})
export class PrivacyComponent {

}



// WEBPACK FOOTER //
// ./src/app/privacy/privacy.component.ts